// @ts-check
import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { Icon } from '@codex/icons';
import styled, { ThemeContext } from 'styled-components';

const IconCDNDesktop = styled.img`
  display: none;

  @media ${({ theme }) => theme.breakpoints.desktop} {
    display: ${({ theme }) => (theme.name === 'brightworld' ? 'block' : 'none')};
  }
`;

const IconCDNMobile = styled.img`
  display: ${({ theme }) => (theme.name === 'brightworld' ? 'block' : 'none')};

  @media ${({ theme }) => theme.breakpoints.desktop} {
    display: none;
  }
`;

export const CustomIcon = (props) => {
  const themeContext = useContext(ThemeContext);
  return (
    <>
      {props.iconCDNDesktop && props.iconCDNDesktop.length > 0 && (
        <IconCDNDesktop
          src={props.iconCDNDesktop}
          className={props.className}
        />
      )}
      {props.iconCDNMobile && props.iconCDNMobile.length > 0 && (
        <IconCDNMobile src={props.iconCDNMobile} className={props.className} />
      )}
      {themeContext.name === 'currys' && props.icon && (
        <Icon icon={props.icon} className={props.className} />
      )}
    </>
  );
};

CustomIcon.propTypes = {
  className: PropTypes.string,
  icon: PropTypes.string,
  iconCDNDesktop: PropTypes.string,
  iconCDNMobile: PropTypes.string
};

CustomIcon.defaultProps = {
  className: '',
  iconCDNMobile: '',
  iconCDNDesktop: '',
  icon: ''
};

export const convertMobileIcon = (icon) => {
  switch (icon) {
    case 'KitchenAppliances':
      return 'https://currys-ssl.cdn.dixons.com/css/themes/dory/icons/WashingMachinePurpleBrightworld.svg';
    case 'Television':
      return 'https://currys-ssl.cdn.dixons.com/css/themes/dory/icons/TvPurpleBrightworld.svg';
    case 'Computing':
      return 'https://currys-ssl.cdn.dixons.com/css/themes/dory/icons/MonitorPurpleBrightworld.svg';
    case 'Gaming':
      return 'https://currys-ssl.cdn.dixons.com/css/themes/dory/icons/GamingPurpleBrightworld.svg';
    case 'Camera':
      return 'https://currys-ssl.cdn.dixons.com/css/themes/dory/icons/CameraPurpleBrightworld.svg';
    case 'Phone':
      return 'https://currys-ssl.cdn.dixons.com/css/themes/dory/icons/MobilePurpleBrightworld.svg';
    case 'SmartTech':
      return 'https://currys-ssl.cdn.dixons.com/css/themes/dory/icons/SmartTechPurpleBrightworld.svg';
    case 'Installation':
      return 'https://currys-ssl.cdn.dixons.com/css/themes/dory/icons/RepairPurpleBrightworld.svg';
    case 'Star':
      return 'https://currys-ssl.cdn.dixons.com/css/themes/dory/icons/StarCopyPurpleBrightworld.svg';
    case 'Deals':
      return 'https://currys-ssl.cdn.dixons.com/css/themes/dory/icons/PricetagWhiteBrightworld.svg';
    case 'HomeOutdoor':
      return 'https://currys-ssl.cdn.dixons.com/css/themes/dory/icons/outdoors.svg';
    default:
      return '';
  }
};
